// SiteSetupDialog.tsx — Site plan settings (site metadata)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';

export default function SiteSetupDialog() {
  const { project, updateSite } = useShallowStore(s => ({
    project:    s.project,
    updateSite: s.updateSite,
  }));

  const site = project?.site;
  const [name,    setName]    = useState(site?.projectName ?? project?.name ?? '');
  const [north,   setNorth]   = useState(site?.northArrow ?? 0);
  const [grid,    setGrid]    = useState(site?.gridSpacing ?? 10);
  const [scale,   setScale]   = useState(site?.scale ?? 96);

  if (!project) return null;

  return (
    <DialogBase
      title="Site Setup"
      onOk={() => updateSite({ projectName: name, northArrow: north, gridSpacing: grid, scale })}
    >
      <div className="dialog-row">
        <label className="dialog-label">Site / Project Name</label>
        <input
          className="dialog-input"
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div className="dialog-row">
        <label className="dialog-label">North Arrow (°)</label>
        <input
          className="dialog-input sm"
          type="number"
          value={north}
          step={5}
          onChange={e => setNorth(parseFloat(e.target.value))}
        />
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Grid Spacing</label>
        <input
          className="dialog-input sm"
          type="number"
          value={grid}
          step={1}
          min={1}
          onChange={e => setGrid(parseFloat(e.target.value))}
        />
        <span className="dialog-unit">ft</span>
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Plot Scale</label>
        <input
          className="dialog-input sm"
          type="number"
          value={scale}
          step={12}
          min={12}
          onChange={e => setScale(parseFloat(e.target.value))}
        />
        <span className="dialog-unit">1:" {scale / 12 | 0}'</span>
      </div>
    </DialogBase>
  );
}
